<template>
    <div class="confirmation">
      <h2>Merci pour votre demande&nbsp;!</h2>
      <p class="font-family-raleway">
        Nous avons bien reçu votre demande de réservation. Notre équipe vous recontactera <strong>sous 24 à 48H</strong> avec une proposition personnalisée adaptée à vos besoins.
      </p>
      <p class="font-family-raleway">
        <strong>Vous avez besoin d’une réponse rapide&nbsp;?</strong>
        Contactez-nous directement au <a href="tel:0626203846">06 26 20 38 46</a>
        ou par e-mail à <a href="mailto:servicecorporate@hortense.green">servicecorporate@hortense.green</a>.
      </p>
      <a href="/" class="return-button">REVENIR À LA PAGE D’ACCUEIL</a>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Confirmation'
  }
  </script>
  
  <style>
  .confirmation {
    margin: 0 auto;
    padding: 2rem;
    text-align: center;
    font-family: 'Merriweather', serif;
  }
  .confirmation h2 {
    margin-bottom: 1rem;
    font-family: 'Merriweather';
    font-weight: 400;
    font-size: 24px;
    margin: 0 0 clamp(10px, 1.8vw, 14px);
  }
  .confirmation p {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
  .confirmation strong {
    font-weight: bold;
  }
  .return-button {
    display: inline-block;
    margin-top: 1.5rem;
    padding: 0.75rem 1.5rem;
    background-color: #345b48;
    color: white;
    text-decoration: none;
    font-weight: 600;
    border: none;
    cursor: pointer;
  }
  .font-family-raleway{
    font-family: 'Raleway', sans-serif;
  }
  </style>